import { render } from "./XLink.vue?vue&type=template&id=174e3d8a&scoped=true"
import script from "./XLink.vue?vue&type=script&lang=js"
export * from "./XLink.vue?vue&type=script&lang=js"

import "./XLink.vue?vue&type=style&index=0&id=174e3d8a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174e3d8a"]])

export default __exports__